import React from 'react';
import styled from 'styled-components';
import Legend from '../../../components/Charts/PieGraph/Legend';
import PieGraph from '../../../components/Charts/PieGraph';
import { I18n } from 'react-redux-i18n';

const AuctionPieChartContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .pieChartContainer {
    min-width: 450px;
    margin-left: 20px;
  }

  @media (max-width: 1200px) {
    .pieChartContainer {
      min-width: 350px;
    }
  }
`;

const VaePieTotal = styled.div`
  border-radius: 4px;
  border: solid 1px rgba(173, 181, 189, 0.2);
  background-color: 'white';
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  margin-bottom: 30px;
  margin-top: 40px;
  width: 100%;

  .title {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 16px;
    line-height: 1.38;
    color: #1f2b37;
  }

  h3 {
    font-family: ${(props) => props.theme.fonts.sfcompact_bold};
    font-size: 30px;
    line-height: 0.8;
    color: #1f2b37;
    margin-top: 5px;

    span {
      font-family: ${(props) => props.theme.fonts.sfcompact};
      font-size: 16px;
      line-height: 1.38;
      color: #1f2b37;
      margin-left: 5px;
    }
  }
`;

const formatSubLabel = (item, type, currency) => {
  if (type === 'value') {
    return item.value.toLocaleString('fr-FR', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
  return item.value + ' bt.';
};

const labels = (data, type, currency) =>
  data.map((item) => ({
    label: item.name,
    percentage: item.percentage,
    subLabel: formatSubLabel(item, type, currency)
  }));

const AuctionPieChart = ({ data, total, type, currency = 'EUR' }) => (
  <AuctionPieChartContainer>
    <div>
      <VaePieTotal>
        <p className="title">
          {I18n.t('auction.auction.valueVolume.totalSales')}
        </p>
        <h3>
          {total.toLocaleString('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })}{' '}
          <span>
            {type === 'value'
              ? Number(null)
                  .toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  })
                  .replace('0', '')
              : 'bt.'}
          </span>
        </h3>
      </VaePieTotal>
      <Legend labels={labels(data, type, currency)} />
    </div>
    <div className="pieChartContainer">
      <PieGraph
        height={window.innerWidth > 1250 ? 450 : 350}
        data={data}
        subKeyTooltip="markets"
      />
    </div>
  </AuctionPieChartContainer>
);

export default AuctionPieChart;
